import React from 'react';
import { array, bool, func } from 'prop-types';
import { Text, Icon, Loading } from '../../../common';
import { GroupedTableWrapper } from '../styles';
import { formatDeliveryDate } from '../marketplaceHelpers';

// Tabla de pedidos con el detalle de productos agrupado por orden (rowspan).
// N° Orden / Fecha / Acción ocupan todo el "cluster" de productos de la orden.
const PendingOrders = ({ orders, loading, onEyeClick }) => {
    if (loading) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <Loading loading />
            </div>
        );
    }

    // Estado inicial (aún no carga): no renderizar nada
    if (orders === null) {
        return null;
    }

    // Sin resultados (p.ej. por filtros de sala/fecha)
    if (orders.length === 0) {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <Icon name='information-circle' size={48} color='#d9d9d9' bottom={16} />
                <Text text='Sin pedidos para el rango seleccionado' size={14} color='#8c8c8c' />
            </div>
        );
    }

    return (
        <GroupedTableWrapper>
            <table>
                <thead>
                    <tr>
                        <th style={{ width: '20%' }}>N° Orden</th>
                        <th style={{ width: '38%' }}>Producto</th>
                        <th style={{ width: '15%' }}>Cant. a producir</th>
                        <th style={{ width: '17%' }}>Fecha de entrega</th>
                        <th style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order, oi) => {
                        const products = order.products || [];
                        const groupBg = oi % 2 === 0 ? '#ffffff' : '#fafbfc';
                        const isLastOrder = oi === orders.length - 1;
                        const { date, time } = formatDeliveryDate(order.deliveryDate);
                        // Borde inferior del cluster (separador grueso entre órdenes)
                        const groupBorder = isLastOrder ? 'none' : '2px solid #d0d0d0';

                        return products.map((p, pi) => {
                            const isFirst = pi === 0;
                            const isLastOfGroup = pi === products.length - 1;
                            const isVeryLast = isLastOrder && isLastOfGroup;
                            const rowBorder = isVeryLast
                                ? 'none'
                                : isLastOfGroup
                                    ? '2px solid #d0d0d0'
                                    : '1px solid #f0f0f0';
                            const name = p.nameComplete || p.name;
                            const qty = p.requestedQuantity != null ? p.requestedQuantity : p.quantityOriginal;

                            return (
                                <tr key={`${order.orderId}-${pi}`} style={{ background: groupBg }}>
                                    {isFirst && (
                                        <td
                                            className='cell-orden'
                                            rowSpan={products.length}
                                            style={{ borderBottom: groupBorder }}
                                        >
                                            {order.orderId}
                                        </td>
                                    )}
                                    <td className='cell-detalle' style={{ borderBottom: rowBorder }}>
                                        {name}
                                    </td>
                                    <td style={{ borderBottom: rowBorder }}>{qty}</td>
                                    {isFirst && (
                                        <td rowSpan={products.length} style={{ borderBottom: groupBorder }}>
                                            <div style={{ fontWeight: 500, color: '#262626' }}>{date}</div>
                                            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{time}</div>
                                        </td>
                                    )}
                                    {isFirst && (
                                        <td
                                            rowSpan={products.length}
                                            style={{ borderBottom: groupBorder, textAlign: 'center' }}
                                        >
                                            <button
                                                type='button'
                                                className='eye-btn'
                                                title='Ver orden'
                                                onClick={() => onEyeClick && onEyeClick(order)}
                                            >
                                                <Icon name='eye' size={20} color='#1FA02E' pointer />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            );
                        });
                    })}
                </tbody>
            </table>
        </GroupedTableWrapper>
    );
};

PendingOrders.propTypes = {
    orders: array,
    loading: bool,
    onEyeClick: func
};

PendingOrders.defaultProps = {
    orders: [],
    loading: false,
    onEyeClick: null
};

export default PendingOrders;
